module.exports = __webpack_public_path__ + "img/02.f0e50fa0.jpg";